module.exports = "/horse-racing/img/vdh-progress.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/horse-racing/img/vdh-progress.png
// module id = 253
// module chunks = 7